import * as React from 'react';
import styled from 'styled-components';
import { FlexColCenter } from '../../../Defaults/Flexbox/Flexbox';
import { DsiOptionChooserItem as OptionChooserItem } from './OptionChooserItem';

const Wrapper = styled(FlexColCenter)`
  width: 100%;
`;

interface Props {
  items: any[];
  selectedOption: any;
  isCartUpdating?: boolean;
  handleOptionClick: (option: any) => void;
  handleZasielkovna?: any;
}

function OptionChooser({
  items,
  selectedOption,
  handleOptionClick,
  handleZasielkovna,
}: Props) {
  return (
    <Wrapper>
      {items &&
        items.map(item => {
          const isZasielkovna = item.id.includes('ZASIELKOVNA');

          const showZBox =
            item?.translations?.length &&
            item?.translations[0]?.showZBox === false
              ? false
              : true;

          const showZPoint =
            item?.translations?.length &&
            item?.translations[0]?.showZPoint === false
              ? false
              : true;

          return (
            <OptionChooserItem
              key={item.id}
              item={item}
              selected={selectedOption ? selectedOption.id === item.id : false}
              // tslint:disable-next-line:jsx-no-lambda
              handleOptionClick={
                isZasielkovna
                  ? () => handleZasielkovna(showZBox, showZPoint)
                  : () => handleOptionClick(item.id)
              }
            />
          );
        })}
    </Wrapper>
  );
}

export { OptionChooser as DsiOptionChooser };
